import React, { useEffect, useContext, Fragment } from "react";
import VideoContext from "../../context/video/videoContext";
import Spinner from "../layouts/Spinner";
import "../../styles/fonts.css";
import { Link } from "react-router-dom";

const VideoDisplay = ({ resource }) => {
  return (
    <div className='embed-responsive embed-responsive-16by9'>
      {resource && resource.url.length > 30 ? (
        <div>
          This resource is unavailable or is not approved by the administrator.
          Please check again later, or email us regarding the problem. Thank
          You!
        </div>
      ) : (
        <iframe
          title={resource.name}
          className='embed-responsive-item'
          width='420'
          height='315'
          src={`https://www.youtube.com/embed/${resource.url}`}
          allowFullScreen
        ></iframe>
      )}
    </div>
  );
};

const NotesDisplay = ({ resource }) => {
  return (
    <div>
      <a
        href={resource.url}
        target='_blank'
        rel='noopener noreferrer'
        className='card-link simplefont size09 d-flex justify-content-center btn btn-block btn-dark'
      >
        view
      </a>
    </div>
  );
};

const LectureDisplay = ({ resource }) => {
  return (
    <div className='embed-responsive embed-responsive-16by9'>
      {" "}
      {(
        <iframe
          title={resource.name}
          className='embed-responsive-item'
          width='420'
          height='315'
          src={`https://drive.google.com/file/d/${resource.url}/preview`}
          allowFullScreen
        ></iframe>
      ) || (
        <div>
          This resource is unavailable or is not approved by the administrator.
          Please check again later, or email us regarding the problem. Thank
          You!
        </div>
      )}
    </div>
  );
};

const Video = (props) => {
  let type = props.match.params.type;

  let coll = props.match.params.collection;
  let id = props.match.params.id;
  const videoContext = useContext(VideoContext);
  const { resource, getResource, getComments } = videoContext;

  useEffect(() => {
    window.scrollTo(0, 0);

    getComments(props.match.params.id);
    if (coll === "acad") {
      getResource({
        id,
      });
    } else if (coll === "extra") {
      getResource({
        id: props.match.params.id,
        collection: "extracurriculars",
      });
    } else {
      getResource({ id, collection: "youtube" });
    }
    return () => {
      videoContext.resourceUnmounts();
    };
    //eslint-disable-next-line
  }, [props.match.params.id]);
  const Changeprop = (button) => {
    let desbox = document.getElementById("description");
    if (desbox.style.display === "none") {
      desbox.style.display = "block";
      button.target.innerHTML = "Hide description";
    } else {
      desbox.style.display = "none";
      button.target.innerHTML = "Click to know more";
    }
  };

  return (
    <div>
      {resource ? (
        <Fragment>
          <h1 className='text-center upperfont'>{resource.name || "null"}</h1>
          <h6 className='text-right slantfont'>
            BY: {resource.author || resource.prof || "null"}
          </h6>
          {type === "lec" ? (
            <LectureDisplay resource={resource} />
          ) : type === "notes" ? (
            <NotesDisplay resource={resource} />
          ) : (
            <VideoDisplay resource={resource} />
          )}
          {resource.tags && (
            <p className='simplefont'>
              tags:{" "}
              {resource.tags.map((tag) => (
                <Link to={`/videos/${tag}`}>
                  <button className='btn btn-link text-lowercase'>
                    #{tag}{" "}
                  </button>
                </Link>
              ))}
            </p>
          )}
          {resource.subject && (
            <p className='d-flex justify-content-between'>
              <span className='fontcool'>Subject:{resource.subject}</span>
              <span className='fontcool'>Branch:{resource.branch}</span>
              <span className='fontcool'>Course:{resource.course}</span>
            </p>
          )}
          <div>
            <button
              id='descriptionbutton '
              onClick={Changeprop}
              type='button'
              className='btn btn-link fontcool'
            >
              View Description
            </button>
            <p
              id='description'
              className='simplefont'
              style={{ display: "none" }}
              className='simplefont'
            >
              {resource.description && resource.description}
            </p>
          </div>
        </Fragment>
      ) : (
        <Spinner />
      )}
    </div>
  );
};

export default Video;
